import { handleAxiosError } from 'core/notifications';
import { useQuery } from '@tanstack/react-query';

import axios from '@/util/axios';

import getAxiosConfig from '../helpers/getAxiosConfig';
import getBootstrapData from '../helpers/getBootstrapData';

import useLegacyCache from './useLegacyCache';

export default ({ isEnabled = false } = {}) => {
  const staleTime = 10000;

  const currentUser = useQuery({
    enabled: isEnabled,
    onError: handleAxiosError,
    queryFn: async () => (await axios(getAxiosConfig('get-current-user'))).data,
    queryKey: ['currentUser'],
    refetchOnWindowFocus: false,
    initialData: getBootstrapData('who_am_i'),
    staleTime,
  });

  const authority = currentUser.data?.authority;
  const isLoggedIn = isEnabled && Boolean(authority) && authority !== 'public';
  const isAdmin = isLoggedIn && authority !== 'student';

  const dependentQueries = {
    adminSettings: useQuery({
      enabled: isAdmin,
      onError: handleAxiosError,
      queryFn: async () => (await axios(getAxiosConfig('get-admin-settings'))).data,
      queryKey: ['adminSettings'],
      refetchOnWindowFocus: false,
      initialData: getBootstrapData('admin_settings'),
      staleTime,
    }),
    currentProfile: useQuery({
      enabled: isLoggedIn,
      queryFn: async () => (await axios(getAxiosConfig('get-current-profile'))).data,
      queryKey: ['currentProfile'],
      refetchOnWindowFocus: false,
      initialData: getBootstrapData('profile'),
      staleTime,
    }),
    learnerSettings: useQuery({
      enabled: isLoggedIn,
      onError: handleAxiosError,
      queryFn: async () => (await axios(getAxiosConfig('get-learner-settings'))).data,
      queryKey: ['learnerSettings'],
      refetchOnWindowFocus: false,
      initialData: getBootstrapData('learner_settings'),
      staleTime,
    }),
    organizations: useQuery({
      enabled: isAdmin,
      onError: handleAxiosError,
      queryFn: async () => (await axios(getAxiosConfig('get-organizations'))).data,
      queryKey: ['organizations'],
      refetchOnWindowFocus: false,
      initialData: getBootstrapData('organizations'),
      staleTime,
    }),
  };

  useLegacyCache({ isEnabled, queryKey: ['adminSettings'] });
  useLegacyCache({ isEnabled, queryKey: ['currentProfile'] });
  useLegacyCache({ isEnabled, queryKey: ['currentUser'] });
  useLegacyCache({ isEnabled, queryKey: ['learnerSettings'] });
  useLegacyCache({ isEnabled, queryKey: ['organizations'] });

  return { currentUser, ...dependentQueries };
};
